import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GuidService {
  constructor() {
    //console.log('GUID Service initialized');
  }

  public get Guid(): string {
    let value = crypto.randomUUID();

    return value;
  }
}
